<div class="container px-0 pt-5 mt-md-3">
  <ng-container *ngIf="summary$ | async as summary">
    <div class="row">
      <div class="col-12"><h1>{{translationPrefix + '.content.heading' | translate}}</h1></div>
    </div>

    <div class="row">
      <div class="col-12">{{translationPrefix + '.content.disclaimer' | translate: summary.transaction}}</div>
    </div>

    <div class="row mt-3">
      <div [innerHTML]="translationPrefix + '.content.transactionInfo' | translate: summary.transaction"
           class="col-12"></div>
    </div>

    <div class="row mt-3">
      <div [innerHTML]="translationPrefix + '.content.blueButton' | translate: summary.blueButton"
           class="col-12">
      </div>
    </div>

    <div class="row mt-4 justify-content-center">
      <div class="col-xs-12 col-sm-6 col-md-4">
        <button (click)="blueButtonClick()"
                class="btn btn-info btn-lg btn-block"
                type="button">{{ 'common.buttonLabels.blueButton' | translate }}</button>
      </div>
    </div>

    <div class="row mt-4 mb-4">
      <div [innerHTML]="translationPrefix + '.content.blueButtonDisclaimer' | translate: summary.blueButton"
           class="col-12">
      </div>
    </div>

    <app-summary
        [summary]="summary"
        [applicationRevision]="summary.revision"
    ></app-summary>

    <div class="container pt-5">
      <div class="row">
        <div class="col-12 p-0">
          <p>{{ summary.materialId }}</p>
        </div>
      </div>
    </div>

  </ng-container>
</div>


